import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { IMPORTS } from './_imports';

@Component({
    selector: 'eula',
    templateUrl: './eula.component.html',
    styleUrl: './eula.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class EulaComponent implements OnInit {
    // #region [props]
    url: string;
    // #endregion

    constructor(private cookieService: CookieService) {
        this.url = atob(this.cookieService.get('prodest-eflow-tcu')).toLowerCase();
    }

    ngOnInit() { }

    // #region [===== private methods =====]
    // #endregion
}
